const NAME = "COMMUNICATION_CHANNEL";

export default NAME;
